function isJSON(str) {
  if (typeof str === 'string') {
    try {
      var obj = JSON.parse(str)
      if (typeof obj === 'object' && obj) {
        return true
      } else {
        return false
      }
    } catch (e) {
      return false
    }
  } else {
    return false
  }
}

export function getSessionStorage(key) {
  const val = sessionStorage.getItem(key)
  return isJSON(val) ? JSON.parse(val) : val
}

export function setSessionStorage(key, val) {
  if (typeof (val) === 'string' || typeof (val) === 'number') {
    sessionStorage.setItem(key, val)
  } else {
    sessionStorage.setItem(key, JSON.stringify(val))
  }
}

export function removeSessionStorage(key) {
  sessionStorage.removeItem(key)
}

export function getLocalStorage(key) {
  const val = localStorage.getItem(key)
  if (typeof (val) === 'string' || typeof (val) === 'number') {
    return localStorage.getItem(key)
  } else {
    return JSON.parse(localStorage.getItem(key))
  }
}

export function setLocalStorage(key, val) {
  if (typeof (val) === 'string' || typeof (val) === 'number') {
    localStorage.setItem(key, val)
  } else {
    localStorage.setItem(key, JSON.stringify(val))
  }
}

export function removeLocalStorage(key) {
  localStorage.removeItem(key)
}
